import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../admin.service';
import {
    MatDialog,
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
    selector: 'app-create-post',
    templateUrl: './create-post.component.html',
    styleUrls: ['./create-post.component.css']
})

export class CreatePost implements OnInit {
    toggleExpandIcon = [false, false, false, false, false, false, false, false];
    selectedMediaName = [];
    selectCategory : any;
    selectedOption : number;
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    createPostForm: FormGroup;
    postName: String = "postName";
    public Editor = ClassicEditor;
    @ViewChild('questionEditor') questionEditor: ElementRef;
    createPollForm: FormGroup;
    pollOptions = [{name: "Option 1*", key: "option1"}, {name: "Option 2*", key: "option2"}]
    minEndDate = new Date();
    endDate = new FormControl;
    endDateForShow = "";
    times: string[] = ["09:00 am", "12:00 pm", "03:00 pm", "06:00 pm"];
    selectedEndTime= "09:00 am";
    multipleOption = false;
    generatePoll = false;
    generatePost = false;
    mediaUrl = "";
    postText = "";
    showReadMore = false;
    showPublish = false;
    isMediaTypeVideo =  false;
    postId = "";
    duplicatePostDetail : any;
    thumbNailLink = "";
    postDetails : any;
    createQandAForm : FormGroup;
    qandAOptions = [{name: "Answer 1*", key: "option1"}, {name: "Answer 2*", key: "option2"}, {name: "Answer 3", key: "option3"},{name: "Answer 4", key: "option4"}]
    correctOption = 0;
    scheduledTime = "";
    scheduleDate = new FormControl();
    isSchedulePost = false;
    isUploaded: boolean = false;
    labelError: string = "";
    originalPostContent: string = "";
    isSingleTypePost: boolean = true;

    ngOnInit(): void {
        this.selectedOption = 1;
        this.selectCategory =[{
            name : "Create Post",
            value: 1,
            checked : true
        },
        {
            name : "Create Poll",
            value: 2,
            checked : false 
        },
        {
            name : "Create Q&A",
            value: 3,
            checked : false
        }
      ]
      this.createPostForm = this._formBuilder.group({
        mediaLink : this._formBuilder.array([]),
        ctaName : [''],
        ctaLink : [''],
        postContent : ['', [Validators.required]],
        postLabel: ['']
      })
      this.createPollForm = this._formBuilder.group({
        ctaName : [''],
        ctaLink : [''],
        mediaLink : this._formBuilder.array([]),
        isMultiple : [false],
        questionText : ['',[Validators.required]],
        option1 : ['',[Validators.required]],
        option2 : ['',[Validators.required]],
        option3 : [''],
        option4 : [''],
        option5 : [''],
        endDate : ['',[Validators.required]],
        pollLabel: [''],
        customResponse: ['']
      })
      this.createQandAForm = this._formBuilder.group({
        ctaName : [''],
        ctaLink : [''],
        mediaLink : this._formBuilder.array([]),
        questionText : ['', [Validators.required]],
        option1 : ['',[Validators.required]],
        option2 : ['',[Validators.required]],
        option3 : [''],
        option4 : [''],
        explanationField: [''],
        QandALabel: ['']
     })
      this.endDate.setValue(new Date());
      this.endDateForShow = this.convertDateTimeToISO(this.endDate, this.selectedEndTime);
      this.postId = this.activatedRoute.snapshot.params.postId;
      this.isSchedulePost = this.activatedRoute.snapshot.params.isSchedule === 'true'
      if(this.postId!='new'){
        this.getPostDetailsForDuplicate()
      }

    }
    constructor(
         private adminService : AdminService,
         private _snackBar: MatSnackBar,
         private _formBuilder: FormBuilder,
         private _matDialog: MatDialog,
         private router : Router,
         private activatedRoute : ActivatedRoute 
         ){}

    getPostDetailsForDuplicate(){
        this.adminService.getPostDetail(this.postId, this.isSchedulePost).subscribe(
            (res)=>{
                this.duplicatePostDetail = res;
                this.originalPostContent = this.extractOriginalContent(res.content);
                this.fillFormWithForDuplicatePost();
                
            }
        )
    }

    extractOriginalContent(content: string): string {
        if (!content) return "";
        
        if (content.startsWith('Copy ')) {
            return content.substring(5);
        }
        
        const copyNumberMatch = content.match(/^Copy\d+\s(.*)$/);
        if (copyNumberMatch) {
            return copyNumberMatch[1];
        }
        
        return content;
    }

    generateCopyPrefix(callback: (prefix: string) => void): void {
        this.getPosts('Published', [], (publishedPosts) => {
            this.getPosts('Scheduled', [], (scheduledPosts) => {
                const combinedPosts = [...publishedPosts, ...scheduledPosts];
                
                const copyNumbers: number[] = [];
                const originalContent = this.originalPostContent;
                
                combinedPosts.forEach(post => {
                    if (post.content) {
                        if (post.content === `Copy ${originalContent}`) {
                            copyNumbers.push(0);
                        } else {
                            const escapedContent = originalContent.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                            const copyMatch = post.content.match(new RegExp(`^Copy(\\d+)\\s${escapedContent}$`));
                            if (copyMatch) {
                                copyNumbers.push(parseInt(copyMatch[1]));
                            }
                        }
                    }
                });
                
                if (copyNumbers.length === 0) {
                    callback('Copy ');
                } else {
                    const maxCopyNumber = Math.max(...copyNumbers);
                    callback(`Copy${maxCopyNumber + 1} `);
                }
            });
        });
    }

    private getPosts(postType: string, allPosts: any[], callback: (posts: any[]) => void, offset: number = 0, limit: number = 100): void {
        this.adminService.getAllPosts(offset, limit, postType).subscribe(
            (response) => {
                const posts = response.data || [];
                const combinedPosts = [...allPosts, ...posts];
                if (posts.length < limit) {
                    callback(combinedPosts);
                } else {
                    this.getPosts(postType, combinedPosts, callback, offset + limit, limit);
                }
            },
        );
    }

    duplicateTextOnlyPost(){
        this.generateCopyPrefix((copyPrefix) => {
            if(this.duplicatePostDetail.deep_link){
                if(this.duplicatePostDetail.content_label){
                    this.createPostForm.patchValue({
                        postLabel: this.duplicatePostDetail.content_label
                    })
                }
                this.createPostForm.patchValue({
                    ctaName : this.duplicatePostDetail.deep_link.text,
                    ctaLink : this.duplicatePostDetail.deep_link.url,
                    postContent : copyPrefix + this.originalPostContent
                })
            } else {
                if(this.duplicatePostDetail.content_label){
                    this.createPostForm.patchValue({
                        postLabel: this.duplicatePostDetail.content_label
                    })
                }
                this.createPostForm.patchValue({
                    postContent : copyPrefix + this.originalPostContent
                })
            }
        });
    }

    duplicateImagesPost(){
        this.generateCopyPrefix((copyPrefix) => {
            const mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
            this.duplicatePostDetail.images.map((value)=>{
                mediaUrlArray.push(new FormControl(value));
            })
                if(this.duplicatePostDetail.deep_link){
                    if(this.duplicatePostDetail.content_label){
                        this.createPostForm.patchValue({
                            postLabel: this.duplicatePostDetail.content_label
                        })
                    }
                this.createPostForm.patchValue({
                    ctaName : this.duplicatePostDetail.deep_link.text,
                    ctaLink : this.duplicatePostDetail.deep_link.url,
                    postContent : copyPrefix + this.originalPostContent
                })
            } else {
                if(this.duplicatePostDetail.content_label){
                    this.createPostForm.patchValue({
                        postLabel: this.duplicatePostDetail.content_label
                    })
                }
                this.createPostForm.patchValue({
                    postContent : copyPrefix + this.originalPostContent
                })
            }
            this.mediaUrl = this.duplicatePostDetail.images[0];
            this.selectedMediaName = this.duplicatePostDetail.images
            if(this.mediaUrl.includes('mp4')) {
                this.isMediaTypeVideo = true;
            }
        });
    }

    duplicatePoll(isMultiplePoll){
        this.generateCopyPrefix((copyPrefix) => {
            this.selectedOption = 2;
            this.selectCategory =[{
                name : "Create Post",
                value: 1,
                checked : false
            },
            {
                name : "Create Poll",
                value: 2,
                checked : true 
            },
            {
                name : "Create Q&A",
                value: 3,
                checked : false
            }
           ]

           if(this.duplicatePostDetail?.deep_link){
            if(this.duplicatePostDetail.content_label){
                this.createPollForm.patchValue({
                    pollLabel: this.duplicatePostDetail.content_label
                })
            }
            this.createPollForm.patchValue({
                isMultiple : isMultiplePoll,
                questionText : copyPrefix + this.originalPostContent,
                ctaName: this.duplicatePostDetail.ctaName,
                ctaLink: this.duplicatePostDetail.ctaLink,
                endDate: this.duplicatePostDetail.expires_at
            })
           } else{
            if(this.duplicatePostDetail.content_label){
                this.createPollForm.patchValue({
                    pollLabel: this.duplicatePostDetail.content_label
                })
            }
            this.createPollForm.patchValue({
                isMultiple : isMultiplePoll,
                questionText : copyPrefix + this.originalPostContent,
                endDate: this.duplicatePostDetail.expires_at
            })
           }

            if(this.duplicatePostDetail.options){
                for(let i=0; i<this.duplicatePostDetail.options.length; i++){
                    if(i>1) this.addOptions();
                    let optionName = `option${i+1}`;
                    this.createPollForm.patchValue({
                        [optionName] : this.duplicatePostDetail.options[i].text
                    })
                }
            }

            if(isMultiplePoll){
                this.onValChange({ checked : true})
            }
        });
    }

    duplicateQuestion(){
        this.generateCopyPrefix((copyPrefix) => {
            this.selectedOption = 3;
            this.selectCategory =[{
                name : "Create Post",
                value: 1,
                checked : false
            },
            {
                name : "Create Poll",
                value: 2,
                checked : true 
            },
            {
                name : "Create Q&A",
                value: 3,
                checked : false
            }
           ]
           const formValues: any = {
            questionText: copyPrefix + this.originalPostContent
           };
          if (this.duplicatePostDetail?.explanation) {
            formValues.explanationField = this.duplicatePostDetail.explanation;
          }
          if (this.duplicatePostDetail?.deep_link) {
            formValues.ctaName = this.duplicatePostDetail.ctaName;
            formValues.ctaLink = this.duplicatePostDetail.ctaLink;
          }
          if(this.duplicatePostDetail?.content_label) {
            formValues.QandALabel = this.duplicatePostDetail.content_label;
          }
          this.createQandAForm.patchValue(formValues);

        if(this.duplicatePostDetail.options){
            for(let i=0; i<this.duplicatePostDetail.options.length; i++){
                let optionName = `option${i+1}`;
                if(this.duplicatePostDetail.options[i].id == this.duplicatePostDetail.correct_option_uuid)
                   this.correctOption = i+1;
                this.createQandAForm.patchValue({
                    [optionName] : this.duplicatePostDetail.options[i].text
                })
            }
        }
        });
    }

    fillFormWithForDuplicatePost(){
        if(this.duplicatePostDetail.type=='text'){
            this.duplicateTextOnlyPost();

        } else if(this.duplicatePostDetail.type=='images'){
            this.duplicateImagesPost();

        } else if(this.duplicatePostDetail.type == 'poll'){
            if(this.duplicatePostDetail.poll_type=='single')
              this.duplicatePoll(false);
            else this.duplicatePoll(true);
        } else if(this.duplicatePostDetail.type == 'question'){
            this.duplicateQuestion();

        }
    }
    expandField(index){
        this.toggleExpandIcon[index] = !this.toggleExpandIcon[index];
    }
    uploadMediaFile(type, file){
        const maxSize = 10 * 1024 * 1024;
        if(file.size > maxSize){
            this._snackBar.open("Size is greater than 10 MB. Please upload a file up to 10 MB.", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
        }
        else {
        this.isUploaded = true;
        this.adminService.uploadPostMedia(type).subscribe(
            (res) =>{
                this.adminService.uploadImageToS3(file, res).subscribe((res)=>{console.log(res)}, (err)=>{console.log(err)});
                const mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
                mediaUrlArray.push(new FormControl(res.post_media_url));
                this.mediaUrl = res.post_media_url;
                this.selectedMediaName.push(file.name);
            },
            (error) =>{
                this._snackBar.open("Something went Wrong, Upload Failed", 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
            }
        )
        }
        // this.adminService.uploadPostMedia(type)
    }
    inputMediaImage(event){
    //    this.selectedMediaName = event.target.files[0].name;
       let type = event.target.files[0].type;
       this.uploadMediaFile(type, event.target.files[0]);
    }
    inputMediaVideo(event){
        // this.selectedMediaName = event.target.files[0].name;
        let type = event.target.files[0].type;
        this.uploadMediaFile(type, event.target.files[0]);
    }
    inputMediaGif(event){
        // this.selectedMediaName = event.target.files[0].name;
        let type = event.target.files[0].type;
        this.uploadMediaFile(type, event.target.files[0]);

    }
    deleteInputMedia(index){
        this.selectedMediaName.splice(index, 1);
        const mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
        mediaUrlArray.removeAt(index);
        this.mediaUrl = ""
        this.isMediaTypeVideo  = false;
        this.thumbNailLink = "";
    }

    addOptions(){
        if(this.pollOptions.length === 5 ) return;
        let optionName = `Option ${this.pollOptions.length + 1}`;
        let keyValue = `option${this.pollOptions.length + 1}`
        this.pollOptions.push({name: optionName, key : keyValue});
    }
    removeOptionWithIndex(index){
        if(this.pollOptions.length <= 2) return;
        this.pollOptions.pop();//(index, 1);
    }
    onEndDateChange(event){
       let isoFormedTime =  this.convertDateTimeToISO(this.endDate, this.selectedEndTime);
       let selectedDate = new Date(isoFormedTime).getTime();
       let currentTime = new Date().getTime();
       if(currentTime>selectedDate){
        this.createPollForm.patchValue({
            endDate: null,
        })
        return;
       }
        this.createPollForm.patchValue({
                endDate: isoFormedTime,
        
        })

    }
    endTimeTrigger(event){
        this.selectedEndTime = event.value;
        let isoFormedTime =  this.convertDateTimeToISO(this.endDate, this.selectedEndTime);
        let selectedDate = new Date(isoFormedTime).getTime();
        let currentTime = new Date().getTime();
        if(currentTime>selectedDate){
          this.createPollForm.patchValue({
                endDate: null,
          })
          return;
        }
         this.createPollForm.patchValue({
                endDate: isoFormedTime,
        
        })
        
    }
    convertDateTimeToISO(selectedDate, time) {
        const dateValue = new Date(selectedDate.value);
        const timeValue = time;
        let [hours, minutes] = timeValue.split(':');
        const isPM = timeValue.toLowerCase().includes('pm');
        if (isPM && hours !== '12') {
            hours = String(parseInt(hours, 10) + 12);
        }
        dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));
        const formattedDate = dateValue.toISOString();
        return formattedDate;
    }
    genratePreview(){
      if(this.selectedOption==1){
        this.generatePost = true;
        this.postText = this.createPostForm.get('postContent').value;
        let mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
        mediaUrlArray = mediaUrlArray.value;
        let mediaFirstPhotoLink = mediaUrlArray.length > 0 ? mediaUrlArray[0] : '';

        this.postDetails = {
            type: 'post',
            content : this.createPostForm.get('postContent').value,
            images : mediaFirstPhotoLink,
            ctaName : this.createPostForm.get('ctaName').value,
            content_label: this.createPostForm.get('postLabel').value
        }

     } else if(this.selectedOption == 2){
        let mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
        mediaUrlArray = mediaUrlArray.value;
        let mediaFirstPhotoLink = mediaUrlArray.length > 0 ? mediaUrlArray[0] : '';
        this.postDetails = {
            type : 'poll',
            content : this.createPollForm.get('questionText').value,
            image: mediaFirstPhotoLink,
            multiple : this.createPollForm.get('isMultiple').value,
            options : [],
            expires_at : this.createPollForm.get('endDate').value,
            ctaName: this.createPollForm.get('ctaName').value,
            ctaLink: this.createPollForm.get('ctaLink').value,
            content_label: this.createPollForm.get('pollLabel').value,
            custom_response_label: this.createPollForm.get('customResponse').value
        }
        for(let i=0; i<this.pollOptions.length; i++){
            let name  = `option${i+1}`;
            this.postDetails['options'].push(this.createPollForm.get(name).value);
        }
         console.log(this.postDetails.image)
      }
      else{
        let mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
        mediaUrlArray = mediaUrlArray.value;
        let mediaFirstPhotoLink = mediaUrlArray.length > 0 ? mediaUrlArray[0] : '';
        this.postDetails = {
            type : 'question',
            image: mediaFirstPhotoLink,
            content : this.createQandAForm.get('questionText').value,
            options : [],
            ctaName: this.createQandAForm.get('ctaName').value,
            ctaLink: this.createQandAForm.get('ctaLink').value,
            explanation: this.createQandAForm.get('explanationField').value,
            content_label: this.createQandAForm.get('QandALabel').value
        }
        for(let i=0; i<this.qandAOptions.length; i++){
            let name  = `option${i+1}`;
            if(this.createQandAForm.get(name).value)
              this.postDetails['options'].push(this.createQandAForm.get(name).value);
        }
     }
     this.showPublish = true;

    }
    allowOnlyDigits(event: KeyboardEvent) {
        const charCode = event.key;
        if (!/^\d$/.test(charCode)) {
          event.preventDefault();
        }
      }
      
      onPasteDigitsOnly(event: ClipboardEvent) {
        event.preventDefault();
        const digits = (event.clipboardData?.getData('text') || '').replace(/\D/g, '');
        document.execCommand('insertText', false, digits);
      }
      
    validateScheduleDateAndTime(){
        if(this.scheduleDate && this.scheduledTime){
            let scheduleTimeIn12 = this.convertTo12HourFormat(this.scheduledTime)
            let isoFormedScheduleTime =  this.convertDateTimeToISO(this.scheduleDate, scheduleTimeIn12);
            let currentTime = new Date().getTime();
            if(currentTime > new Date(isoFormedScheduleTime).getTime())
              return false;

            if(this.selectedOption == 2 && this.createPollForm.get('endDate').value){  // check in poll section end time is > then schedule time
                let endTime = new Date(this.createPollForm.get('endDate').value).getTime();
                let sheduleTime = new Date(isoFormedScheduleTime).getTime();
                if(endTime < sheduleTime) return false;
            }
            return true;
        }
        else 
         return false;
    }
    validateAllField(){
        if(this.postName.length == 0) return false;
        if(this.selectedOption==1 && !this.createPostForm.valid) return false;
        if(this.selectedOption==2 && !this.createPollForm.valid) return false;
        if(this.selectedOption==3 && !this.createQandAForm.valid) return false;
        if(this.selectedOption == 2){
            if(this.createPollForm.get('questionText').value && this.createPollForm.get('questionText').value.length<2) return false;
            if(this.createPollForm.get('option1').value && this.createPollForm.get('option1').value.length<2) return false;
            if(this.createPollForm.get('option2').value && this.createPollForm.get('option2').value.length<2) return false;
            if(this.createPollForm.get('option3').value && this.createPollForm.get('option3').value.length<2) return false;
            if(this.createPollForm.get('option4').value && this.createPollForm.get('option4').value.length<2) return false;
            if(this.createPollForm.get('option5').value && this.createPollForm.get('option5').value.length<2) return false;
        }
        if(this.selectedOption == 3){
            if(this.correctOption == 3 && !this.createQandAForm.get('option3').value)
              this.correctOption = 0;
            if(this.correctOption == 4 && !this.createQandAForm.get('option4').value)
              this.correctOption = 0;
            if(this.correctOption == 0) return false;
            if(this.createQandAForm.get('questionText').value && this.createQandAForm.get('questionText').value.length<2) return false;
            if(this.createQandAForm.get('option1').value && this.createQandAForm.get('option1').value.length<2) return false;
            if(this.createQandAForm.get('option2').value && this.createQandAForm.get('option2').value.length<2) return false;
            if(this.createQandAForm.get('option3').value && this.createQandAForm.get('option3').value.length<2) return false;
            if(this.createQandAForm.get('option4').value && this.createQandAForm.get('option4').value.length<2) return false;
        }
        if(this.isSchedulePost && !this.validateScheduleDateAndTime())
          return false;
        return true;
    }
    onValChange(event){
        this.isSingleTypePost = !this.isSingleTypePost;
        this.createPollForm.patchValue({
            isMultiple : event.checked
        })
        if(event.checked){
            this.pollOptions = [{name: "Option 1*", key: "option1"}, {name: "Option 2*", key: "option2"}, {name: "Option 3*", key: "option3"}];
            this.createPollForm.patchValue({
                option3 : "",
                option4 : "",
                option5 : ""
            })
        }
        else {
            this.pollOptions = [{name: "Option 1*", key: "option1"}, {name: "Option 2*", key: "option2"}];
            this.createPollForm.patchValue({
                option3 : "",
                option4 : "",
                option5 : ""
            })

        }
    }
    onUploadButtonClick(){
        const dialogRef = this._matDialog.open(AddVideoLink, {
            data: { },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if(result){
             this.selectedMediaName.push(result.data.videoName);
              this.isMediaTypeVideo  = true;
              this.mediaUrl = result.data.videoLink
              this.thumbNailLink = result.data.thumbNail
            }
          })
    }
    publishPost(){
        let reqBody={};
        if(this.selectedOption==1){
            if(this.selectedMediaName.length==0){
                reqBody ={
                    type : "text",
                    content : this.createPostForm.get('postContent').value
                }
                if(this.createPostForm.get('ctaLink').value || this.createPostForm.get('ctaName').value){
                    reqBody['deep_link'] = {
                        url : this.createPostForm.get('ctaLink').value,
                        text : this.createPostForm.get('ctaName').value
                    }
                }
                const postLabelValue = this.createPostForm.get('postLabel').value;
                if (postLabelValue !== null && postLabelValue !== undefined && postLabelValue !== '') {
                    reqBody['content_label'] = postLabelValue;
                }
            }
            else if(this.isMediaTypeVideo){
                    reqBody = {
                        type: 'video_stream',
                        url: this.mediaUrl,
                        protocol : 'hls',
                        content: this.createPostForm.get('postContent').value,
                        thumbnail: this.thumbNailLink
                    
                 }
                 if(this.createPostForm.get('ctaLink').value || this.createPostForm.get('ctaName').value){
                    reqBody['deep_link'] = {
                        url : this.createPostForm.get('ctaLink').value,
                        text : this.createPostForm.get('ctaName').value
                    }
                }
                const postLabelValue = this.createPostForm.get('postLabel').value;
                if (postLabelValue !== null && postLabelValue !== undefined && postLabelValue !== '') {
                    reqBody['content_label'] = postLabelValue;
                }

            } 
            else {
                const mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
                reqBody ={
                    type : "images",
                    images: mediaUrlArray.value,
                    content : this.createPostForm.get('postContent').value
                }
                if(this.createPostForm.get('ctaLink').value || this.createPostForm.get('ctaName').value){
                    reqBody['deep_link'] = {
                        url : this.createPostForm.get('ctaLink').value,
                        text : this.createPostForm.get('ctaName').value
                    }
                }
                const postLabelValue = this.createPostForm.get('postLabel').value;
                if (postLabelValue !== null && postLabelValue !== undefined && postLabelValue !== '') {
                    reqBody['content_label'] = postLabelValue;
                }

            }
        } else if(this.selectedOption==2) {
            let options = [];
            for(let i=0; i<this.pollOptions.length; i++){
                let name  = `option${i+1}`;
                options.push(this.createPollForm.get(name).value);
            }
            if(this.selectedMediaName.length === 0){
                if(this.createPollForm.get('isMultiple').value){
                    reqBody ={
                        type: "poll",
                        poll_type : "multiple",
                        content : this.createPollForm.get('questionText').value,
                        options: options,
                        expires_at : this.createPollForm.get('endDate').value
                    }
                    if(this.createPollForm.get('ctaLink').value || this.createPollForm.get('ctaName').value){
                        reqBody['deep_link'] = {
                            url : this.createPollForm.get('ctaLink').value,
                            text : this.createPollForm.get('ctaName').value
                        }
                    }
                    const pollLabelValue = this.createPollForm.get('pollLabel').value;
                    if (pollLabelValue !== null && pollLabelValue !== undefined && pollLabelValue !== '') {
                        reqBody['content_label'] = pollLabelValue;
                    }
                }
                else {
                    reqBody = {
                        type: "poll",
                        poll_type : "single",
                        content : this.createPollForm.get('questionText').value,
                        options: options,
                        expires_at : this.createPollForm.get('endDate').value
    
                    }
                    if(this.createPollForm.get('ctaLink').value || this.createPollForm.get('ctaName').value){
                        reqBody['deep_link'] = {
                            url : this.createPollForm.get('ctaLink').value,
                            text : this.createPollForm.get('ctaName').value
                        }
                    }
                    const pollLabelValue = this.createPollForm.get('pollLabel').value;
                    if (pollLabelValue !== null && pollLabelValue !== undefined && pollLabelValue !== '') {
                        reqBody['content_label'] = pollLabelValue;
                    }
                    if(this.createPollForm.get('customResponse').value){
                        reqBody['custom_response_label'] = this.createPollForm.get('customResponse').value;
                    }
                }
            }
            else{
                const mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
                if(this.createPollForm.get('isMultiple').value){
                    reqBody ={
                        type: "poll",
                        images: mediaUrlArray.value,
                        poll_type : "multiple",
                        content : this.createPollForm.get('questionText').value,
                        options: options,
                        expires_at : this.createPollForm.get('endDate').value
                    }
                    if(this.createPollForm.get('ctaLink').value || this.createPollForm.get('ctaName').value){
                        reqBody['deep_link'] = {
                            url : this.createPollForm.get('ctaLink').value,
                            text : this.createPollForm.get('ctaName').value
                        }
                    }
                    const pollLabelValue = this.createPollForm.get('pollLabel').value;
                    if (pollLabelValue !== null && pollLabelValue !== undefined && pollLabelValue !== '') {
                        reqBody['content_label'] = pollLabelValue;
                    }
                }
                else {
                    reqBody = {
                        type: "poll",
                        images: mediaUrlArray.value,
                        poll_type : "single",
                        content : this.createPollForm.get('questionText').value,
                        options: options,
                        expires_at : this.createPollForm.get('endDate').value
    
                    }
                    if(this.createPollForm.get('ctaLink').value || this.createPollForm.get('ctaName').value){
                        reqBody['deep_link'] = {
                            url : this.createPollForm.get('ctaLink').value,
                            text : this.createPollForm.get('ctaName').value
                        }
                    }
                    const pollLabelValue = this.createPollForm.get('pollLabel').value;
                    if (pollLabelValue !== null && pollLabelValue !== undefined && pollLabelValue !== '') {
                        reqBody['content_label'] = pollLabelValue;
                    }
                    if(this.createPollForm.get('customResponse').value){
                        reqBody['custom_response_label'] = this.createPollForm.get('customResponse').value;
                    }
    
                }
            }
        }
        else {
            let options = [];
            for(let i=0; i<this.qandAOptions.length; i++){
                let name  = `option${i+1}`;
                if(this.createQandAForm.get(name).value)
                  options.push(this.createQandAForm.get(name).value);
            }
            if(this.selectedMediaName.length === 0){
                reqBody = {
                    type: 'question',
                    options : options,
                    content : this.createQandAForm.get('questionText').value,
                    correct_option_number :this.correctOption
                }
                if(this.createQandAForm.get('ctaLink').value || this.createQandAForm.get('ctaName').value){
                    reqBody['deep_link'] = {
                        url : this.createQandAForm.get('ctaLink').value,
                        text : this.createQandAForm.get('ctaName').value
                    }
                }
                if(this.createQandAForm.get('explanationField').value){
                    reqBody['explanation'] = this.createQandAForm.get('explanationField').value;
                }
                const QandALabelValue = this.createQandAForm.get('QandALabel').value;
                if (QandALabelValue !== null && QandALabelValue !== undefined && QandALabelValue !== '') {
                    reqBody['content_label'] = QandALabelValue;
                }
            }
            else{
                const mediaUrlArray = this.createPostForm.get('mediaLink') as FormArray;
                reqBody = {
                    type: 'question',
                    images: mediaUrlArray.value,
                    options : options,
                    content : this.createQandAForm.get('questionText').value,
                    correct_option_number :this.correctOption
                }
                if(this.createQandAForm.get('ctaLink').value || this.createQandAForm.get('ctaName').value){
                    reqBody['deep_link'] = {
                        url : this.createQandAForm.get('ctaLink').value,
                        text : this.createQandAForm.get('ctaName').value
                    }
                }
                if(this.createQandAForm.get('explanationField').value){
                    reqBody['explanation'] = this.createQandAForm.get('explanationField').value;
                }
                const QandALabelValue = this.createQandAForm.get('QandALabel').value;
                if (QandALabelValue !== null && QandALabelValue !== undefined && QandALabelValue !== '') {
                    reqBody['content_label'] = QandALabelValue;
                }
            }
        }
        if (reqBody['content_label'] !== undefined && reqBody['content_label'] !== null && reqBody['content_label'] !== '' && (reqBody['content_label'] < 1 || reqBody['content_label'] > 200)) {
            this.labelError = "Label should have a number between 1 and 200";
        }
          
        if(this.isSchedulePost){
            let scheduleTimeIn12 = this.convertTo12HourFormat(this.scheduledTime)
            let isoFormedScheduleTime =  this.convertDateTimeToISO(this.scheduleDate, scheduleTimeIn12);
            reqBody['scheduled_time'] = isoFormedScheduleTime;

        }
        this.adminService.postFeed(reqBody, this.isSchedulePost).subscribe(
            (res)=>{
                this._snackBar.open("Post SuccessFully posted", 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
                this.router.navigateByUrl('/admin/social-hub/post-hub');
            },
            (error)=>{
                this._snackBar.open(error.error.message, 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
            }
        )
    }
    convertTo12HourFormat(time24) {
        var timeArray = time24.split(':');
        var hours = timeArray[0];
        hours = parseInt(hours)
        var minutes = timeArray[1];
        minutes = parseInt(minutes);
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; 
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var time12 = hours + ':' + minutes+ ' ' + ampm;
        return time12;
    }

}


@Component({
    selector: 'app-video-add',
    templateUrl: './video-add.component.html',
    styleUrls: ['./create-post.component.css']
})
export class AddVideoLink implements OnInit {
    videoName = "";
    videoLink = "";
    thumbNailUrl = "";
    thumbNailName = "";
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    ngOnInit(): void {
    }
    constructor(
        public dialogRef: MatDialogRef<AddVideoLink>, 
        private adminService : AdminService,         
        private _snackBar: MatSnackBar,
        ){}

    saveVideoLink(){
        if(this.videoLink=="" || this.videoName =="" || this.thumbNailUrl ==="") return;
        this.dialogRef.close({
            event: 'close',
            data: {
              videoLink: this.videoLink,
              videoName: this.videoName,
              thumbNail : this.thumbNailUrl
        }})
    }

    inputMediathumbNail(event){
       let type = event.target.files[0].type;
       this.uploadMediaFile(type, event.target.files[0]);
    }
    uploadMediaFile(type, file){
        this.adminService.uploadPostMedia(type).subscribe(
            (res) =>{
                this.adminService.uploadImageToS3(file, res).subscribe((res)=>{console.log(res)}, (err)=>{console.log(err)});
                this.thumbNailUrl = res.post_media_url;
                this.thumbNailName = file.name;
            },
            (error) =>{
                this._snackBar.open("Something went Wrong, Upload of Thumbnail Failed", 'close', {
                    duration: 4000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
            }
        )
    }

}

